module.exports = __webpack_public_path__ + "static/footer-3a1a2e2fc7742e669648c56e2b290755.jpg";